export default {"src":"/_next/static/media/always-on-hand-spiritory-icon.088a08fe.svg","height":29,"width":29,"blurWidth":0,"blurHeight":0};